import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    "id": null, // optional 
    "ten": null, // required Tên nguồn tin tức
    "hien_thi": null, // required hien thi
    "thoi_diem_tao": null, // required Thời gian tạo bản ghi
    "nguoi_tao": null, // required 
    "thoi_diem_sua_cuoi": null, // required Thời gian lần sửa bản ghi cuối cùng
    "nguoi_sua_cuoi": null, // required Mã người sửa cuối
}

model.validForm = {
    "ten": [ValidService.required], // required Tên nguồn tin tức
    "hien_thi": [ValidService.required], // required hien thi
}

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
    },
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {

        },
        valid: {

        },
        operator: {

        }
    },
    vn_text: ""
};

export default model;